(function () {
  /**
   * Newsletter / formularios Oleum.
   * Shopify.captcha.protect(form, cb) → submit nativo SOLO en el callback.
   * Nunca enviar sin token (Missing CAPTCHA token).
   */
  var LOADING_LABEL = 'Enviando…';

  function getFeedbackEl(form) {
    return form.querySelector('[data-oleum-form-feedback]');
  }

  function ensureFeedbackEl(form) {
    var el = getFeedbackEl(form);
    if (el) return el;
    el = document.createElement('p');
    el.className = 'oleum-form-feedback';
    el.setAttribute('data-oleum-form-feedback', '');
    el.hidden = true;
    form.appendChild(el);
    return el;
  }

  function showFeedback(form, type, message) {
    var el = ensureFeedbackEl(form);
    el.hidden = false;
    el.textContent = message;
    el.classList.remove('is-success', 'is-error');
    el.classList.add(type === 'success' ? 'is-success' : 'is-error');
    el.setAttribute('role', type === 'success' ? 'status' : 'alert');
  }

  function hideFeedback(form) {
    var el = getFeedbackEl(form);
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
    el.classList.remove('is-success', 'is-error');
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    var label = btn.querySelector('span:not(.svg-wrapper)') || btn;
    if (!btn.dataset.oleumLabel) {
      btn.dataset.oleumLabel = label.textContent.trim();
    }
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    label.textContent = loading ? LOADING_LABEL : btn.dataset.oleumLabel;
  }

  function waitForCaptchaApi(attempts) {
    attempts = attempts || 0;
    return new Promise(function (resolve) {
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        resolve(true);
        return;
      }
      if (attempts >= 40) {
        resolve(false);
        return;
      }
      setTimeout(function () {
        waitForCaptchaApi(attempts + 1).then(resolve);
      }, 100);
    });
  }

  function nativeSubmit(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function resetFormState(form, btn) {
    form.dataset.oleumSubmitting = '0';
    setLoading(btn, false);
  }

  function submitWithCaptcha(form, btn) {
    hideFeedback(form);
    setLoading(btn, true);

    waitForCaptchaApi().then(function (ready) {
      if (!ready) {
        resetFormState(form, btn);
        showFeedback(
          form,
          'error',
          'No se pudo verificar el captcha. Desactiva el bloqueador de anuncios e inténtalo de nuevo.'
        );
        return;
      }

      var done = false;
      var safety = setTimeout(function () {
        if (done) return;
        done = true;
        resetFormState(form, btn);
        showFeedback(
          form,
          'error',
          'El captcha tardó demasiado. Recarga la página e inténtalo otra vez.'
        );
      }, 20000);

      try {
        // Docs Shopify: el callback se ejecuta cuando el captcha está listo para enviar.
        window.Shopify.captcha.protect(form, function () {
          if (done) return;
          done = true;
          clearTimeout(safety);
          try {
            nativeSubmit(form);
          } catch (e) {
            resetFormState(form, btn);
            showFeedback(
              form,
              'error',
              'No se pudo enviar. Desactiva el bloqueador de anuncios e inténtalo de nuevo.'
            );
          }
        });
      } catch (e) {
        if (done) return;
        done = true;
        clearTimeout(safety);
        resetFormState(form, btn);
        showFeedback(form, 'error', 'Error al preparar el captcha. Recarga e inténtalo de nuevo.');
      }
    });
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches) return;
    if (form.matches('.oleum-newsletter-dual')) {
      onDualNewsletterSubmit(event);
      return;
    }
    if (!form.matches('.oleum-ajax-form')) return;

    event.preventDefault();
    event.stopPropagation();

    if (form.dataset.oleumSubmitting === '1') return;
    form.dataset.oleumSubmitting = '1';

    var btn = form.querySelector('[type="submit"]');
    submitWithCaptcha(form, btn);
  }

  function ensureMarketingField(form) {
    if (form.querySelector('[name="contact[accepts_marketing]"]')) return;
    var formType = form.querySelector('[name="form_type"]');
    if (formType && formType.value && formType.value !== 'customer') return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'contact[accepts_marketing]';
    input.value = 'true';
    form.appendChild(input);
  }

  function warmCaptcha(form) {
    if (!window.Shopify || !window.Shopify.captcha || typeof window.Shopify.captcha.protect !== 'function') {
      return;
    }
    try {
      window.Shopify.captcha.protect(form);
    } catch (e) {
      /* ignore */
    }
  }

  var SIGNUP_PRODUCT_KEY = 'oleum_signup_product';

  function readStoredSignupProduct() {
    try {
      var raw = sessionStorage.getItem(SIGNUP_PRODUCT_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function storeSignupProduct(handle, title) {
    if (!handle) return;
    try {
      sessionStorage.setItem(
        SIGNUP_PRODUCT_KEY,
        JSON.stringify({
          handle: String(handle),
          title: String(title || handle),
        })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function buildSignupTags(baseTags, productHandle) {
    var tags = String(baseTags || 'newsletter').trim() || 'newsletter';
    if (!productHandle) return tags;
    if (tags.indexOf('pdp-signup') === -1) {
      tags += ', pdp-signup';
    }
    var productTag = 'product:' + productHandle;
    if (tags.indexOf(productTag) === -1) {
      tags += ', ' + productTag;
    }
    return tags;
  }

  function applyStoredSignupProduct(form) {
    var tagsInput = form.querySelector('[data-oleum-signup-tags], [name="contact[tags]"]');
    if (!tagsInput) return;
    var stored = readStoredSignupProduct();
    if (!stored || !stored.handle) return;
    tagsInput.value = buildSignupTags(tagsInput.value, stored.handle);
  }

  function bindScrollSubscribe(root) {
    (root || document).querySelectorAll('[data-oleum-scroll-subscribe]').forEach(function (btn) {
      if (btn.dataset.oleumScrollSubscribeBound) return;
      btn.dataset.oleumScrollSubscribeBound = '1';
      btn.addEventListener('click', function () {
        storeSignupProduct(btn.getAttribute('data-product-handle'), btn.getAttribute('data-product-title'));
        var target =
          document.getElementById('oleum-footer-signup') ||
          document.getElementById('oleum-footer-newsletter');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          var email = target.querySelector('input[type="email"]');
          if (email) email.focus({ preventScroll: true });
        }, 450);
      });
    });
  }

  function newsletterApiUrl() {
    return (
      window.OLEUM_NEWSLETTER_API ||
      'https://h-ai.com.mx/ov/apps/order-tracking-php/api/newsletter-signup.php'
    );
  }

  function readFormValue(form, names) {
    for (var i = 0; i < names.length; i += 1) {
      var el = form.querySelector('[name="' + names[i] + '"]');
      if (el && el.value) return String(el.value).trim();
    }
    return '';
  }

  function resolveSignupTags(form) {
    var tags = form.getAttribute('data-signup-tags') || 'newsletter';
    var tagsInput = form.querySelector('[data-oleum-signup-tags]');
    if (tagsInput && tagsInput.value) {
      tags = tagsInput.value;
    }
    var stored = readStoredSignupProduct();
    if (stored && stored.handle) {
      tags = buildSignupTags(tags, stored.handle);
    }
    return tags;
  }

  function resolveProductTitle(form) {
    var title = form.getAttribute('data-product-title') || '';
    if (title) return title;
    var stored = readStoredSignupProduct();
    return stored && stored.title ? stored.title : '';
  }

  function submitNewsletterApi(form, btn, options) {
    options = options || {};
    hideFeedback(form);

    var email = readFormValue(form, ['email', 'contact[email]']);
    var firstName = readFormValue(form, ['first_name', 'contact[first_name]']);
    var payload = {
      email: email,
      first_name: firstName,
      tags: resolveSignupTags(form),
      source: form.getAttribute('data-signup-source') || 'web',
      product_title: resolveProductTitle(form),
    };

    if (!email) {
      if (!options.quiet) {
        showFeedback(form, 'error', 'Ingresa un correo válido.');
      }
      return Promise.resolve(false);
    }

    return fetch(newsletterApiUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.data || result.data.ok !== true) {
          if (!options.quiet) {
            var err =
              (result.data && (result.data.error || result.data.reason)) ||
              'No se pudo enviar el correo de confirmación. Intenta de nuevo.';
            showFeedback(form, 'error', err);
          }
          return false;
        }
        if (!options.quiet) {
          var msgEl = form.querySelector('[data-oleum-success-message]');
          var msg = (msgEl && msgEl.textContent.trim()) || '¡Gracias por suscribirte!';
          showFeedback(form, 'success', msg);
        }
        try {
          sessionStorage.removeItem(SIGNUP_PRODUCT_KEY);
        } catch (e) {
          /* ignore */
        }
        return true;
      })
      .catch(function () {
        if (!options.quiet) {
          showFeedback(form, 'error', 'Error de conexión. Revisa tu red e inténtalo otra vez.');
        }
        return false;
      });
  }

  function onDualNewsletterSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('.oleum-newsletter-dual')) return;

    event.preventDefault();
    event.stopPropagation();

    if (form.dataset.oleumSubmitting === '1') return;
    form.dataset.oleumSubmitting = '1';

    var btn = form.querySelector('[type="submit"]');
    applyStoredSignupProduct(form);
    setLoading(btn, true);

    submitNewsletterApi(form, btn, { quiet: true }).finally(function () {
      submitWithCaptcha(form, btn);
    });
  }

  function onNewsletterSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('.oleum-newsletter-api-form')) return;

    event.preventDefault();
    event.stopPropagation();

    if (form.dataset.oleumSubmitting === '1') return;
    form.dataset.oleumSubmitting = '1';

    var btn = form.querySelector('[type="submit"]');
    setLoading(btn, true);
    submitNewsletterApi(form, btn).finally(function () {
      resetFormState(form, btn);
    });
  }

  function initNewsletterForm(form) {
    if (!form || form.dataset.oleumNewsletterInit === '1') return;
    form.dataset.oleumNewsletterInit = '1';
    form.addEventListener('submit', onNewsletterSubmit, true);
  }

  function initForm(form) {
    if (!form || form.dataset.oleumAjaxInit === '1') return;
    form.dataset.oleumAjaxInit = '1';
    form.setAttribute('data-shopify-captcha', 'true');
    ensureMarketingField(form);
    applyStoredSignupProduct(form);
    form.addEventListener('submit', onSubmit, true);

    form.addEventListener(
      'focusin',
      function () {
        warmCaptcha(form);
      },
      { once: true }
    );
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('form.oleum-ajax-form').forEach(initForm);
    scope.querySelectorAll('form.oleum-newsletter-api-form').forEach(initNewsletterForm);
    bindScrollSubscribe(scope);
  }

  function showPostedSuccess() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') !== 'true' && params.get('contact_posted') !== 'true') {
        return;
      }
      var form =
        document.querySelector('form.oleum-newsletter-dual') ||
        document.querySelector('form.oleum-ajax-form') ||
        document.querySelector('.oleum-newsletter-split__form') ||
        document.querySelector('.oleum-footer__newsletter-form') ||
        document.querySelector('.oleum-asociate-signup__form');
      if (!form) return;
      var msgEl = form.querySelector('[data-oleum-success-message]');
      var msg = (msgEl && msgEl.textContent.trim()) || '¡Gracias!';
      showFeedback(form, 'success', msg);
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      /* ignore */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      showPostedSuccess();
    });
  } else {
    init();
    showPostedSuccess();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
